import { action, makeObservable, observable } from "mobx"

import { refundsApi } from "@src/shared/api"
import {
  RefundCreate,
  RefundCreateFeePayerEnum,
} from "@src/shared/api/generated"
import { loading } from "@src/shared/classes/utils/loading"

export interface RefundCreateRequest {
  convert_token?: string
  otp: string
}

export type RefundFormType = {
  address: string
  fee_payer: RefundCreateFeePayerEnum
}

export type PaymentInfoType = {
  amount: string
  network: string
  symbol: string
}

export abstract class RefundEntity extends loading(["create"]) {
  state: RefundFormType = {} as RefundFormType

  constructor() {
    super()

    makeObservable(this, {
      setState: action.bound,
      state: observable.shallow,
    })
  }

  protected async _create(req: RefundCreateRequest) {
    const request: RefundCreate = {
      ...this.state,
      ...req,
      payment_id: this.paymentId,
    }

    return refundsApi.createRefund(request).then((_) => true)
  }

  setState(state: RefundFormType) {
    this.state = {
      ...this.state,
      ...state,
    }
  }

  abstract create(req: RefundCreateRequest): Promise<boolean>
  abstract get paymentId(): string
  abstract get paymentInfo(): PaymentInfoType
}
